import { useMemo } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { ChevronLeft, Sliders } from 'lucide-react'
import { ALL_SETTINGS_SECTIONS } from './settings/settingsConfig'

export default function SettingsPage() {
  const location = useLocation()
  const navigate = useNavigate()

  const isOverview = location.pathname === '/app/settings' || location.pathname === '/app/settings/'

  // Match the active section for breadcrumb & header in detailed view
  const currentSection = useMemo(() => {
    // Sort by href length descending so specific subpaths match first
    const sorted = [...ALL_SETTINGS_SECTIONS].sort((a, b) => b.href.length - a.href.length)
    return sorted.find((s) => location.pathname === s.href || location.pathname.startsWith(s.href + '/'))
  }, [location.pathname])

  if (isOverview) {
    return <Outlet />
  }

  const Icon = currentSection?.icon || Sliders

  return (
    <div className="space-y-6 w-full max-w-[1800px] mx-auto pb-12">
      {/* Detailed View Header matching Company People styling */}
      <div className="flex items-center justify-between border-b border-border pb-4">
        <div className="flex items-center gap-3 min-w-0">
          <button
            type="button"
            onClick={() => navigate('/app/settings')}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold text-muted-foreground hover:text-foreground bg-card hover:bg-muted rounded-lg border border-border transition-all shadow-2xs group shrink-0 cursor-pointer"
          >
            <ChevronLeft className="w-4 h-4 transition-transform group-hover:-translate-x-0.5 text-muted-foreground group-hover:text-foreground" />
            <span>Back to Settings</span>
          </button>

          <div className="h-4 w-px bg-border shrink-0" />

          <div className="flex items-center gap-2.5 min-w-0">
            {currentSection && (
              <div
                className={`w-7 h-7 rounded-lg flex items-center justify-center shrink-0 shadow-2xs ${currentSection.iconBg}`}
              >
                <Icon className="w-3.5 h-3.5" />
              </div>
            )}
            <div className="flex items-center gap-1.5 min-w-0 text-xs truncate">
              <span className="text-muted-foreground hidden sm:inline">Settings</span>
              <span className="text-muted-foreground/50 hidden sm:inline">/</span>
              {currentSection?.category && (
                <>
                  <span className="text-muted-foreground hidden md:inline">
                    {currentSection.category}
                  </span>
                  <span className="text-muted-foreground/50 hidden md:inline">/</span>
                </>
              )}
              <h1 className="text-xs sm:text-sm font-bold text-foreground truncate">
                {currentSection?.label || 'Configuration'}
              </h1>
            </div>
          </div>
        </div>

        <button
          onClick={() => navigate('/app/settings')}
          className="text-xs text-muted-foreground hover:text-primary transition-colors hidden sm:block"
        >
          All modules
        </button>
      </div>

      {/* Content */}
      <div className="min-w-0">
        <Outlet />
      </div>
    </div>
  )
}
